export default "__VITE_ASSET__CFE1BJBO__"